<mat-card-subtitle style="margin-top: 16px;">
  {{containerDesc}}
</mat-card-subtitle>

<form class="dynamic-form" [formGroup]="form" style="width: 100%">
  <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">

    <mat-form-field fxFlex="25" width="100%">
      <mat-label>Amount Paid</mat-label>
      <input matInput style="text-align: right;" type="number" formControlName="amountPaid" autocomplete="new-password"
        (keyup)="amountPaidChanged()" (focusout)="amountPaidFocusOut()">
    </mat-form-field>

    <mat-form-field fxFlex="25" width="100%">
      <mat-label>Amount Tendered</mat-label>
      <input matInput style="text-align: right;" type="number" formControlName="amountTendered">
    </mat-form-field>

    <mat-form-field fxFlex="25" width="100%">
      <mat-label>Minus Outstanding</mat-label>
      <input matInput style="text-align: right;" type="number" formControlName="amountOutstanding">
    </mat-form-field>

    <mat-form-field fxFlex="25" width="100%">
      <mat-label>{{paymentType && paymentType === 'REFUND' ? 'Equals New Balance' : 'Equals Change'}}</mat-label>
      <input matInput style="text-align: right;" type="number" formControlName="amountDifference">
    </mat-form-field>
  </div>
</form>
